import type { ReactNode } from 'react';
import { DialogBase, type DialogBaseProps, useModalBackClose } from './DialogBase';

export interface ModalProps extends Omit<DialogBaseProps, 'mode' | 'children'> {
  children: ReactNode;
}

export function Modal(props: ModalProps) {
  return <DialogBase {...props} mode="modal" />;
}

export { useModalBackClose };
